<nav class="side-floating-menu hide-in-{{ hideBreakpoint }}">
  <ul>
    @for (option of options; track $index) {
      <li [attr.data-scroll-id]="option.id">
        {{ option.title }}
      </li>
    }
  </ul>
</nav>
